import { gql } from '@apollo/client';

export const LINKED_INTERVENTION_INSTITUTIONS = gql`
  query LinkedInterventionInstitutions($input: FilterInstitutions!) {
    institutions: filteredInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          emisNumber
          cohorts {
            id
            name
            isInstitutionCohort
            isInterventionCohort
            isPeopleCohort
            intervention {
              id
            }
          }
          district {
            id
            name
          }
          type {
            id
            name
          }
        }
      }
    }
  }
`;
